<template>
  <div class="card-wrap m-auto mb-2 mt-3 d-flex bg-white">
    <img v-lazy = "ImgPreUrl+ infoItem.pic" class="item-img" :key="infoItem.id">
    <div class="d-center-between w-80">
      <div class="pl-5">
        <h4 style="border-bottom: orange 1px solid;width: 100%;padding-bottom: 5px" class="text-center">
          {{infoItem.tit}}</h4>
        <p class="pt-2 cursor-pointer text-link text-left"
           @click="$router.push('/index_hotel/hotel_detail/'+infoItem.id)">活动酒店：{{infoItem.title}}</p>
        <p class="text-left pt-1">活动日期：{{infoItem.startdate | formatTimestamp}} - {{infoItem.enddate |
          formatTimestamp}}</p>
      </div>
      <div class="d-center-between w-40">
        <p class="h4">
          <span class="text-success" v-if="infoItem.saleStatus==1">进行中</span>
          <span class="text-danger" v-if="infoItem.saleStatus==2">已结束</span>
        </p>
        <el-button type="primary" @click="goHotelActivity">查看详细</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState,mapGetters} from 'vuex'
  export default {
    name: 'ListCard',
    computed:{
      ...mapState(['userLoginMessage']),
      ...mapGetters(['userInfo']),
    },
    props: {
      infoItem: {
        type: Object,
        default() {
          return {}
        }
      }
    },
    methods:{
      goHotelActivity(item) {
        /*管理员和采购商可查看*/
        if (this.userInfo.en === 'hotel' || this.userInfo.en === 'homestay')
          this.$alert('您不是采购商，无法查看该页面', '提示', {
            confirmButtonText: '确定',
            center:true});
        else this.$router.push({path:'/index/index_hotel_activity/activity_detail',query:{saleId:this.infoItem.onSaleId}});
      }
    }
  }
</script>

<style scoped lang="scss">
  .card-wrap {
    margin: 20px 0;
    border-radius: 10px;
    width: 1200px;
    border: 1px solid #f3f3f3;
    /*box-shadow: 4px 4px 10px #f3f3f3;*/
    &:hover {
      box-shadow: 4px 4px 10px #e9e9e9;
    }
  }

  .item-img {
    width: 200px;
    height: 140px;
    border-radius: 10px;
  }
</style>
